<template>
  <div>
    <section
      class="box-detail form-detail"
      v-if="dataContract.lstAppendixQrConnectors && dataContract.lstAppendixQrConnectors.length > 0"
    >
      <h1>Phụ lục qr connectors</h1>
      <div
        class="table-responsive"
        v-for="(item, index) in dataContract.lstAppendixQrConnectors"
        :key="index"
      >
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Số phụ lục</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-right">Trạng thái</th>
              <th scope="col" class="text-right">Trạng thái Mpos</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' ||
                      item.state === 'APPROVED' ||
                      item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td align="right">
                <span class="badge" v-bind:class="[item.state ? item.state : '']">{{
                  item.state ? item.state : '' | mapTextStatus(listStatusContract)
                }}</span>
                <div
                  v-if="
                    item.state && (item.state === 'REJECTED_SA' || item.state === 'REJECTED_MA')
                  "
                >
                  <p
                    class="form-control-plaintext f12"
                    v-if="
                      item.reasonRejected && item.reasonRejected[item.reasonRejected.length - 1]
                    "
                  >
                    {{
                      item.reasonRejected ? item.reasonRejected[item.reasonRejected.length - 1] : ''
                    }}
                  </p>
                </div>
              </td>
              <td>
                <span v-if="item.mposStt" class="badge" :class="item.mposStt">
                  {{ item.mposStt | transformData(Config.mposStt) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
      }
    },
  }
</script>

<style scoped></style>
